import { render } from "./ReviewQuestion.vue?vue&type=template&id=77f2c602"
import script from "./ReviewQuestion.vue?vue&type=script&lang=js"
export * from "./ReviewQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__